<!--基础排班时间表-->
<template>
  <div>
    <!-- <div class="title-container" shadow="never" style="margin-top: 0px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">课程模板</span>
      </div>
      <div>
        <el-switch style="margin-right: 10px;"
                   v-model="inAutoRelaease"
                   @change="changeAutoRelease"
                   active-text="自动发布课程"
        />
        <span style="font-size: 15px;margin-left: 30px; margin-right: 10px;">一节课基础课时间:</span>
        <el-button type="primary" size="medium" class="operator-btn"
                   icon="el-icon-edit"
                   @click="onSetOneClassTimeShowDig()">{{oneClassTime}}分钟</el-button>
        <span style="font-size: 15px;margin-left: 30px; margin-right: 10px;">课程名:</span>
        <el-button type="primary" size="medium" class="operator-btn"
                   icon="el-icon-folder-checked"
                   @click="onSetLessonNameShowDig()">{{lessonName}}</el-button>

        <el-button type="warning" size="medium" class="operator-btn2" style="margin-right: 0px;"
                   icon="el-icon-circle-plus-outline" @click="onOpenAddClass()">添加排班</el-button>
        <el-button type="warning" size="medium" class="operator-btn2" style="margin-right: 0px;"
                   icon="el-icon-circle-plus-outline" @click="onOpenAddClass2()">添加自定义课程</el-button>
      </div>
    </div> -->
    <div class="table-container" style="margin-top: 0px;">
      <el-table :key="refreshTimer" :data="tableData" :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }" max-height="520" border>
        <el-table-column :label="tableTitleData.swTeacher" prop="swTeacher">
          <template slot-scope="scope">
            <!-- <div>
              {{ scope.row.time }}
            </div> -->
            <el-time-picker style="width: 120px" disabled v-model="scope.row.time" format="HH:mm" value-format="HHmm"
              :picker-options="{ selectableRange: '00:00:00- 23:59:59' }" placeholder="时间" />
          </template>
        </el-table-column>
        <el-table-column label="业务" prop="serviceName">
          <!-- <template slot-scope="scope">
            <div>
              {{ scope.row.time }} -->
          <!-- </div> -->
          <!-- <el-time-picker style="width: 120px"
                            v-model="scope.row.time"
                            format="HH:mm"
                            value-format="HH:mm"
                            :picker-options="{selectableRange: '00:00:00- 23:59:59'}"
                            placeholder="时间"/> -->
          <!-- </template> -->
        </el-table-column>
        <el-table-column label="周一" prop="one"></el-table-column>
        <el-table-column label="周二" prop="two"></el-table-column>
        <el-table-column label="周三" prop="three"></el-table-column>
        <el-table-column label="周四" prop="four"></el-table-column>
        <el-table-column label="周五" prop="five"></el-table-column>
        <el-table-column label="周六" prop="six"></el-table-column>
        <el-table-column label="周日" prop="day"></el-table-column>
        <!-- <el-table-column v-for="(titleItem,idx) in tableTitleData.time" v-bind:key="idx" :label="titleItem">
          <template slot-scope="scope" >
            <div>
              {{ scope.row.cn[idx][0] }}
            </div> -->
        <!-- <el-row v-if="scope.row.type == 'default'">
              婴儿
              <el-input  v-model="scope.row.cn[idx][0]" style="width: 100px"></el-input>
            </el-row>
            <el-row style="margin-top: 5px;" v-if="scope.row.type == 'default'">
              幼儿
              <el-input  v-model="scope.row.cn[idx][1]" style="width: 100px"></el-input>
            </el-row>
            <el-row style="margin-top: 5px;" v-if="scope.row.type != 'default'">
              {{scope.row.name}}
              <el-input  v-model="scope.row.cn[idx][0]" style="width: 100px"></el-input>
            </el-row> -->
        <!-- </template>
        </el-table-column> -->
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="onDelOneItem(scope.$index)" type="warning" size="mini" icon="el-icon-delete"
              plain>删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-card class="operate-container" style="width: 100%;border: 0px;" shadow="never">
      <el-button type="primary" class="operator-btn" @click="onClickReleaseLesson">发布课程(本周)</el-button>
      <el-button type="primary" class="operator-btn" @click="onClickReleaseLessonNextWeek">发布课程(下周)</el-button>
      <el-button type="primary" class="operator-btn" @click="onClickSave">保存模板</el-button>
    </el-card>
    <!--    添加排班-->
    <el-dialog title="添加排班" :visible.sync="visibleDlgAddClass" width="50%" center>
      <div>
        <el-form ref="registerRef" label-width="150px">
          <el-form-item :label="tableTitleData.swTeacher + ':'">
            <el-time-picker style="width: 300px" v-model="addItemParam.time" format="HH:mm" value-format="HH:mm"
              :picker-options="{ selectableRange: '00:00:00- 23:59:59' }" placeholder="时间" />
          </el-form-item>

          <el-form-item v-for="(titleItem, idx) in tableTitleData.time" v-bind:key="idx" :label="titleItem + ':'">
            <el-row>
              <span>婴儿</span>
              <el-input v-model="addItemParam.cn[idx][0]" style="width: 100px"></el-input>
              <span style="margin-left: 20px;">幼儿</span>
              <el-input v-model="addItemParam.cn[idx][1]" style="width: 100px"></el-input>
            </el-row>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="visibleDlgAddClass = false">取消</el-button>
        <el-button type="success" @click="onAddOneItem('default')">确认</el-button>
      </span>
    </el-dialog>
    <el-dialog title="添加自定义课程" :visible.sync="visibleDlgAddClass2" width="50%" center>
      <div>
        <el-form ref="registerRef" label-width="150px">
          <el-form-item :label="tableTitleData.swTeacher + ':'">
            <el-time-picker style="width: 300px" v-model="addItemParam.time" format="HH:mm" value-format="HH:mm"
              :picker-options="{ selectableRange: '00:00:00- 23:59:59' }" placeholder="时间" />
          </el-form-item>
          <el-form-item label="课程名称:">
            <el-input v-model="addItemParam.name" style="width: 100px"></el-input>
          </el-form-item>
          <el-form-item label="会员卡子类型:">
            <el-select v-model="addItemParam.cardSubTypeId" placeholder="会员卡子类型" clearable style="width: 300px;">
              <el-option v-for="item in subCardTypes" :key="item.id" :label="item.type" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item v-for="(titleItem, idx) in tableTitleData.time" v-bind:key="idx" :label="titleItem + ':'">
            <el-row>
              <el-input v-model="addItemParam.cn[idx][0]" style="width: 100px"></el-input>
            </el-row>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="visibleDlgAddClass2 = false">取消</el-button>
        <el-button type="success" @click="onAddOneItem('customer')">确认</el-button>
      </span>
    </el-dialog>
    <el-dialog title="设置一节基础课时间" :visible.sync="visibleDlgSetClassTime" width="50%" center>
      <el-form ref="registerRef" label-width="150px">
        <el-form-item label="时间:">
          <el-input style="width: 300px;" v-model="oneClassTime"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="visibleDlgSetClassTime = false">取消</el-button>
        <el-button type="primary" @click="onSetOneClassTime">确认</el-button>
      </span>
    </el-dialog>
    <el-dialog title="设置基础课程名" :visible.sync="visibleDlgSetLessonName" width="50" center>
      <el-form ref="registerRef" label-width="150px">
        <el-form-item label="课程名:">
          <el-input style="width: 300px;" v-model="lessonName"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="visibleDlgSetLessonName = false">取消</el-button>
        <el-button type="primary" @click="onSetLessonName">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<style scoped>
.table-container {
  border: 0px;
}

/deep/ .el-table th.el-table__cell>.cell {
  /* width: 99%; */
  /* height: auto; */
  background: #ecf3fd;
  /* border-radius: 8px; */
}

/deep/ .el-table__header-wrapper .cell {
  line-height: 60px;
  color: #0d6fb8;
}

/deep/ .el-dialog--center {
  /* border: 2px solid #d0d0d0; */
  border-radius: 10px;
}

/deep/ .el-dialog__header {
  text-align: left;
  /* border-radius: 10px;
  background: #f0f7ff; */
}

/deep/ .el-table .el-table__cell {
  padding: 0px;
}

/deep/ .el-table--enable-row-transition .el-table__body td.el-table__cell {
  padding: 12px 0;
}
</style>
<script>
import globaldata from "../../../../utils/globaldata";
import commonUtils from "../../../../utils/commonUtils";
import messageUtils from "../../../../utils/messageUtils";
import { getCardSubTypeList, } from "../../../../api/StoreLessonCard";
import {
  getAutoRelease,
  getBsLessonName,
  getClassTimeBs,
  getScheLessonBsTemplate, setAutoRelease, setBsLessonName, setClassTimeBs,
  setScheLessonBsTemplate
} from "../../../../api/StoreSetting";
import { releaseBsWeekLesson } from "../../../../api/StoreReleaseLesson";
import { formatDate } from "../../../../utils/date";
export default {
  name: 'SchelingBaseTime',
  props: {
    cns: Array,
  },
  data() {
    return {
      visibleDlgSetClassTime: false,
      visibleDlgSetLessonName: false,
      tableTitleData: {
        swTeacher: "时间(时:分)",
        time: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
      },
      weekTime: "",
      tableData: [
      ],
      addItemParam: [],
      inAutoRelaease: false, //是否自动发布
      oneClassTime: 0,
      lessonName: "",
      visibleDlgAddClass: false,
      visibleDlgAddClass2: false,
      refreshTimer: 'refreshTimer',
      subCardTypes: [],
    }
  },
  created() {
    this.initData();
    this.getSubTypeList();
  },
  methods: {
    getSubTypeList() {
      let param = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        storeLessonCardTemplateId: 2
      }
      this.subCardTypes = []
      getCardSubTypeList(param).then(response => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        for (let i = 0; i < data.length; ++i) {
          let option = {
            id: data[i].id,
            type: data[i].name,
          }
          this.subCardTypes.push(option);
        }

      })
    },
    Scheli(val) {
      this.tableData.push(val);
      this.fdsa();
      console.log(this.tableData, val, 'this.table==========1111')
    },
    fdsa() {
      this.tableData.sort(function (a, b) {
        return Number(a.time) - Number(b.time);
      });
    },
    initData() {

      this.resetAddOne();


      let param = {
        id: globaldata.getAdminStore().storeFrontId

      }
      getScheLessonBsTemplate(param).then(response => {
        if (response.code == 20000) {
          let data = response.data;
          let cnTimes = data.cnTimes;
          let cns = JSON.parse(cnTimes);
          this.tableData = cns
          this.fdsa();
          console.log(this.tableData, 'this.tableData====')
        }
        // let data = response.data;
        // if (commonUtils.isObjectNull(data)){
        //   return;
        // }
        // let cnTimes = data.cnTimes;
        // if (commonUtils.isStringNull(cnTimes)){
        //   return;
        // }
        // let cns = JSON.parse(cnTimes);
        // this.resetTimesSche(cns);
        // this.refreshData(cns);

      })
      // this.getClassTimeBs();
      // this.getBsLessonName();
      // this.getAutoRelease();

    },
    onOpenAddClass() {
      this.resetAddOne();
      this.visibleDlgAddClass = true;
    },
    onOpenAddClass2() {
      this.resetAddOne();
      this.visibleDlgAddClass2 = true;
    },
    resetAddOne() {
      this.addItemParam = {
        time: "00:00", //时间
        //孩子数量
        cn: [
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
        ],
        name: '',
        type: '',

      }
    },
    //重置所有人排班
    resetTimesSche(times) {

      this.tableData = [];
      for (let i = 0; i < times.length; ++i) {
        let ld = {
          time: times[i],
          cn: [
            [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]
          ]
        }
        this.tableData.push(ld);
      }
    },
    refreshData(cn) {

      this.tableData = cn;
    },

    onDelOneItem(index) {
      this.tableData.splice(index, 1);
    },

    onAddOneItem(type) {
      let tb = {
        time: this.addItemParam.time,
        cn: this.addItemParam.cn,
        type: type,
        name: this.addItemParam.name,
        cardSubTypeId: this.addItemParam.cardSubTypeId,
      }
      this.tableData.push(tb);
      this.resetAddOne();
    },
    onGetBaseTime() {
      return this.tableData;
    },

    /**
     * 保存模板
     */
    onClickSave() {
      //  let osdf = ''
      //   this.tableData.forEach((item)=>{
      //     osdf = JSON.stringify(item.serviceId)
      //     item.serviceId = osdf
      //   })
      //  console.log(JSON.stringify(this.tableData),'this.tableData==')
      // return
      let param = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        cnTimes: JSON.stringify(this.tableData),

      }
      const loading = this.myLoading();
      setScheLessonBsTemplate(param).then(response => {
        let date = response.data;
        if (commonUtils.isObjectNull(date)) {
          return;
        }
        messageUtils.successMsg(this, "保存成功");
        loading.close();
      })


    },

    onClickReleaseLesson() {
      let day = new Date();
      this.onReleaseLesson(day)
    },
    onClickReleaseLessonNextWeek() {
      let day = new Date();
      let nextDay = day.getTime() + (7 * 24 * 3600000);
      day = new Date(nextDay);
      this.onReleaseLesson(day)
    },
    onReleaseLesson(day) {
      const loading = this.myLoading();
      let param = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        adminId: globaldata.getAdminStore().id,
        adminWord: "123456",
        day: formatDate(day, "yyyy-MM-dd")

      }
      releaseBsWeekLesson(param).then(response => {
        loading.close();
        let date = response.data;
        if (commonUtils.isObjectNull(date)) {
          return;
        }
        messageUtils.successMsg(this, response.message);

      })
    },

    getClassTimeBs() {
      let param = {
        id: globaldata.getAdminStore().storeFrontId,
      }
      getClassTimeBs(param).then(response => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        this.oneClassTime = data;

      })
    },

    getBsLessonName() {
      let param = {
        id: globaldata.getAdminStore().storeFrontId,
      }
      getBsLessonName(param).then(response => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        this.lessonName = data;

      })
    },
    getAutoRelease() {
      let param = {
        id: globaldata.getAdminStore().storeFrontId,
      }
      getAutoRelease(param).then(response => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        this.inAutoRelaease = data;

      })
    },
    changeAutoRelease(val) {
      let param = {
        id: globaldata.getAdminStore().storeFrontId,
        auto: val,
      }
      setAutoRelease(param).then(response => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        if (data == true) {
          messageUtils.successMsg(this, response.message)
        } else {
          messageUtils.errorMsg(this, response.message)
        }
      })
    },

    onSetLessonNameShowDig() {
      this.visibleDlgSetLessonName = true;
    },
    onSetLessonName() {
      let param = {
        id: globaldata.getAdminStore().storeFrontId,
        lessonName: this.lessonName
      }
      setBsLessonName(param).then(response => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        if (data == true) {
          messageUtils.successMsg(this, response.message)
          this.visibleDlgSetLessonName = false;
        } else {
          messageUtils.errorMsg(this, response.message)
        }

      })

    },

    onSetOneClassTimeShowDig() {
      this.visibleDlgSetClassTime = true;
    },
    onSetOneClassTime() {
      let param = {
        id: globaldata.getAdminStore().storeFrontId,
        min: this.oneClassTime
      }
      setClassTimeBs(param).then(response => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        if (data == true) {
          messageUtils.successMsg(this, response.message);
          this.visibleDlgSetClassTime = false;
        } else {
          messageUtils.errorMsg(this, response.message)
        }

      })
    }
  }
}
</script>






// WEBPACK FOOTER //
// src/views/my-store/sw-teacher-scheduling-bs/components/SchelingBaseTime.vue